export const PARTNERS_DATA_LOAD_REQUEST = '@OXD/PARTNERS_DATA_LOAD_REQUEST'
export const PARTNERS_DATA_LOAD_SUCCESS = '@OXD/PARTNERS_DATA_LOAD_SUCCESS'
export const PARTNERS_DATA_LOAD_FAILURE = '@OXD/PARTNERS_DATA_LOAD_FAILURE'

export const PARTNERS_PROFILE_LOAD_REQUEST = '@OXD/PARTNERS_PROFILE_LOAD_REQUEST'
export const PARTNERS_PROFILE_LOAD_SUCCESS = '@OXD/PARTNERS_PROFILE_LOAD_SUCCESS'
export const PARTNERS_PROFILE_LOAD_FAILURE = '@OXD/PARTNERS_PROFILE_LOAD_FAILURE'

export const PARTNERS_DOWNLOAD_REPORT_EVENTS_REQUEST = '@OXD/PARTNERS_DOWNLOAD_REPORT_EVENTS_REQUEST'
export const PARTNERS_DOWNLOAD_REPORT_EVENTS_SUCCESS = '@OXD/PARTNERS_DOWNLOAD_REPORT_EVENTS_SUCCESS'
export const PARTNERS_DOWNLOAD_REPORT_EVENTS_FAILURE = '@OXD/PARTNERS_DOWNLOAD_REPORT_EVENTS_FAILURE'

export const PARTNERS_DOWNLOAD_REPORT_EVENTS_RESET = '@OXD/PARTNERS_DOWNLOAD_REPORT_EVENTS_RESET'
